import { React, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {addMonthsToDateString,
      getFormattedDate,isEndDateGreater,changeDateFormat,getMonthRange,
      getFridayDates,shortMonthToMonthNumber
  } from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import  {getWholeSaleRawWoolReport}  from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';





function WholeSaleRawwoolReport() {

    // const token = useContext(MyContextProvider).token;
    // const decode_token = jwtDecode(token);
    const decode_token = getUserClaimsForUi();
    const token = decode_token
    const [startDate, setStartDate] = useState(null);
    const [district, setDistrict] = useState('');
    const [reportType, setReportType] = useState('');
    const [isDistrict, setIsDistrict] = useState(true);
    const storedLanguage = localStorage.getItem('language');
    const today = new Date();
    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // };
    const config = getAuthHeaders();

 
  
// Handle on change Event ********
const handleDropdownChange = (e) => {
      setStartDate(e);
 };


const handleOnChange=(e)=>{

  const {name, value}=e.target;
  switch(name){
    case 'report_type':
       setReportType(value)
       if (value === 'districtWise') {
        setIsDistrict(true);
      } else {
        setIsDistrict(false);
      }
      
     break;
    case 'district':
       setDistrict(value)
       break;
       default:
        console.log("Switch case is not match");

  }
}
   
   

   //handle excel sheet ***************
const handleGenerateExcel = async() => {

        if(reportType===''){
         toast.error('Please select Report Type', messages.COLOR_RED);
          return
        }
        if(isDistrict && district===''){
          toast.error('Please select District', messages.COLOR_RED);
           return
         }
        if (!startDate) {
            toast.error('Please select the date', messages.COLOR_RED);
            return;
        }



    try {
    showLoading(true);

        let post_data={
          reportType: reportType,
          fromDate:getFormattedDate(startDate)
        }

        if(isDistrict){
          post_data.districtCode= district
         }
        const response = await axios.post(`${API_URL}api/price/priWholeSaleRawWoolReport`, post_data, config);
        const reportData = response.data;
      if(reportData.status){
            let allData= reportData.data;
            downloadReport(allData,post_data)

        }else{
          toast.error('Data is not found', messages.COLOR_RED);
        return;
        }

    } catch (error) {
    console.error(error);

    }finally{
    showLoading(false);
    }
   }


   

   const formatGrossValue = (value) => {
    if (value === 0) return '0.00';
    if (value === "NaN" ) return '';
    if (value === '' || value === null) return '0.00';
    return Number(value).toFixed(2);
    };
   
   
   const downloadReport=(allData,objectPostData)=>{
    let excelObjectData='';
    let transformedData='';
    const formattedDate = objectPostData.fromDate.charAt(0).toUpperCase() + objectPostData.fromDate.slice(1).toLowerCase();
 if(objectPostData.reportType==='monthly'){
  
    transformedData=allData.map(item => [
    item.DISTRICT_NAME_HINDI,
    `${item.ITEM_NAME} ${item.ITEM_VARIETY_NAME}`,
    formatGrossValue(item.CONTROLLED_PRICE),
    ]);

   excelObjectData = {
               reportType:"monthly",
                fileName:`rawWoolMonthly(${formattedDate.replace(/ /g, "_")})`,
                fileType:'xls',
                sheetName: 'rawWoolMonthly',
                firstRowMergeCells: 'A1:C1',
                firstRowExportDate:  changeDateFormat(new Date()),
                secondRowMergeCells: 'A2:C2',
                secondRowText: `कच्चे ऊन के उत्पादक थोक भाव माह - ${formattedDate}`,
                headerHindiColumns:['बाजार का नाम','ऊन की किस्म','औसत '],
                headerNumberColumns: [1,2,3],
                excelRowData:transformedData,
              };
 }


 if(objectPostData.reportType==='districtWise'){



   let data =objectPostData.fromDate.split(" ");
   let monthInDigit=shortMonthToMonthNumber(data[0])
  let fridayDates = getFridayDates(data[1], monthInDigit);
  const fridayAllDates = fridayDates.map(date => {
    const datePart = date.split(' - ')[1];
    return datePart.replace(/\//g, '-');
  });
     



   transformedData=allData[0].groupCodes.map(item => [
    item.ITEM_VARIETY_NAME,
    item.ITEM_UNIT_NAME,
    formatGrossValue(item.FIRST_FRI_PRICE),
    formatGrossValue(item.SECOND_FRI_PRICE),
    formatGrossValue(item.THIRD_FRI_PRICE),
    formatGrossValue(item.FOURTH_FRI_PRICE),
    (fridayAllDates.length === 4) ? '':formatGrossValue(item.FIFTH_FRI_PRICE),
    formatGrossValue(item.CONTROLLED_PRICE),
    ]);

    if(fridayAllDates.length === 4){
      fridayAllDates.push('');
     }

   excelObjectData = {
                reportType:"districtWise",
                fileName:`rawWOOL(${formattedDate.replace(/ /g, "_")})`,
                fileType:'xls',
                sheetName: 'rawWool',
                firstRowMergeCells: 'A1:H1',
                firstRowExportDate:  changeDateFormat(new Date()),
                secondRowMergeCells: 'A2:H2',
                secondRowText:   `अर्थ एंव संख्या प्राभाग राज्य नियोजन संस्था उत्तर प्रदेश कच्चे ऊन के थोक भावं`,
                thirdRowText:   [allData[0].districtName,'','','','','',formattedDate,''],
                fourthRowText:   ['बस्तुओं की किस्म','प्रति मापदण्ड ','शुक्रवार के वास्तिविक थोक भाव','','','','','साधारण औसत'],
                fifthRowText:   ['','',...fridayAllDates,''],
                excelRowData:transformedData,
              };
 }


 



        excelObjectData.excelRowData = transformedData;
   
        getWholeSaleRawWoolReport(excelObjectData);
    }
   
     return (
       <>
           <ToastContainer />
           <GlobalLoading />
           <div className="container-fluid py-3">
               <div className="card mx-3 mb-3">
                   <div className="card-body pb-1">
                       <div className="row align-items-center">
                           <h4 className="page_heading">
                               <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.WHOLE_SALE_RAW_WOOL_REPORT : priceTitle.en.WHOLE_SALE_RAW_WOOL_REPORT }} />
                           </h4>
                           <div className="row align-items-center">
                               
                           <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                               <label> Select  Type</label>
   
                               <select  
                               name="report_type" 
                               className="form-select"
                               onChange={handleOnChange}
                               value={reportType}
                               >
                               <option value="" disabled>[---Select--]</option>
                               <option value="districtWise">District Wise</option>
                               <option value="monthly">Monthly Wise</option>
                             </select>
   
                           </div>
                           {
                            isDistrict &&
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                            <label> Select District</label>

                            <select  
                            name="district" 
                            className="form-select"
                            onChange={handleOnChange}
                            value={district}
                            >
                            <option value="" disabled>[---Select--]</option>
                            <option value="28" className="from-txtbx3">Raebareli</option>
                           <option value="36" className="from-txtbx3">Jhansi</option>
                           <option value="45" className="from-txtbx3">Prayagraj</option>
                           <option value="64" className="from-txtbx3">Jaunpur</option>
                           <option value="68" className="from-txtbx3">Bhadoi</option>
                          </select>

                        </div>
                            
                           }
                          
   
   
                           <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                               <label className="fw-bold h6">Select Date</label>
                               <DatePicker
                                   className="form-control calendar_icon"
                                   selected={startDate}
                                   onChange={handleDropdownChange}
                                   dateFormat="MMM yyyy"
                                   showMonthYearPicker
                                   placeholderText="Select month"
                                   name="startDate"
                                   maxDate={today}
                               />
                           </div>
   
   
   
   
                           <div className="col-xl-2 col-lg-4 mb-3">
                               <label className="w-100 d-none d-sm-block">&nbsp;</label>
                               <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                           </div>
                           </div>
   
   
                       </div>
                   </div>
               </div>
           </div>
      </>
     )
   }

export default WholeSaleRawwoolReport